module.exports = __webpack_public_path__ + "img/P150T_weapon_44.b2b1b842.png";